import { render, staticRenderFns } from "./loMain.vue?vue&type=template&id=324c9159&scoped=true&"
import script from "./loMain.vue?vue&type=script&lang=js&"
export * from "./loMain.vue?vue&type=script&lang=js&"
import style0 from "./loMain.vue?vue&type=style&index=0&id=324c9159&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324c9159",
  null
  
)

export default component.exports